import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";
import axios from 'axios';

const AboutOne = ({ id }) => {
  const [aboutData, setAboutData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    axios.get('https://solanthegroup.com/admin/api/abouts')
      .then(response => {
        if (response.data.length > 0) {
          setAboutData(response.data[0]);
        }
      })
      .catch(error => console.error("Error fetching about data:", error));

    const wow = new WOW.WOW({ live: false });
    wow.init();


  }, []);

  if (!aboutData) return <div></div>;

  return (
    <div id={id}>
      <div className="about-area tmp-section-gap about-style-one">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 m-0">
                  {/* <img className='wow zoomIn'
                   style={{width:"65%",height:"600px",objectFit:"cover!important"}} 
                   alt="corporate_business" src={`https://solanthegroup.com/admin/${aboutData.first_photo}`} />
                  <div className="image-two wow" style={{width:"33%.3",height:"52%",objectFit:"cover!important"}} >
                    <img alt="corporate_business"
                     style={{width:"100%",height:"100%",objectFit:"cover"}} 
                     src={`https://solanthegroup.com/admin/${aboutData.second_photo}`} />
                  </div>
                  <div className="image-three wow"  style={{width:"80%!important",height:"33%"}} >
                    <img alt="corporate_business" 
                    style={{width:"100%!important",height:"100%",objectFit:"cover!important"}} 
                    src={`https://solanthegroup.com/admin/${aboutData.third_photo}`} />
                  </div>
                  <div className="square" />
                  <div className="flower">
                    <img alt="Corporate_Business" src="assets/images/about/flower.png" />
                  </div> */}
                    <img alt="corporate_business"  style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"10px"}} 
                    src={`https://solanthegroup.com/admin/${aboutData.third_photo}`} />
            </div>
            <div className="col-lg-6">
              <div className="about-inner">
                <div className="section-head text-align-left section-head-one-side">
                  <div className="section-sub-title wow slideInUp" data-wow-duration=".4s" data-wow-delay=".1s">
                    <img alt="Corporate_service" src="assets/images/services/section-custom-menubar.png" />
                    <span className="subtitle">{aboutData.info_title}</span>
                  </div>
                  <h2 className="title split-collab wow slideInUp" data-wow-duration=".4s" data-wow-delay=".2s">
                    {aboutData.first_title} <br /> {aboutData.second_title}
                  </h2>
                </div>
                <p className="description wow slideInUp">{aboutData.description}</p>
                <div className="single-progress-area progress-stye-one wow slideInUp" data-wow-duration=".4s" data-wow-delay=".2s">

                  {aboutData.progress_bars && JSON.parse(aboutData.progress_bars).map((bar, index) => (
                    <div key={index} className="progress-top">
                      <div className="w-100 mb-3">
                        <div className="d-flex justify-content-between font-weight-500">
                          <div className="progress-title">{bar.title}</div>
                          <div className="progress-number">{bar.number}</div>  
                        </div>
                        <div className="progress">
                          <div className="progress-bar wow fadeInLeft bg--primary" role="progressbar" style={{ width: `${bar.number}%` }} />
                        </div>
                      </div>
                    </div>
                  ))}



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .font-weight-500 {
            color: black;
            font-size: 16px;
            font-weight: 500;
        }

        @media only screen and (max-width: 767px) {
          .image-two{
            width:50% !important;
            height:52% !important;

          }
          .image-two img{
            width:100% !important;
            height:100% !important;
            object-fit:cover !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutOne;
